import React from 'react';
import { compose } from 'recompose';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import Modal from '../../Common/Modal';
import config from '../../../config';
import ReminderModal from './ReminderModal';
import EditReminderForm from './EditReminderForm';

class EditReminderModal extends ReminderModal {
  getAjaxObject(params) {
    return {
      method: 'PUT',
      dataType: 'json',
      contentType: 'application/json',
      url: `${config.localeApi}/reminders/${this.props.reminder.user_reminder_id}`,
      data: JSON.stringify(params)
    };
  }

  handleSuccess() {
    toastr.success(
      this.props.t('account.dashboard_remind_me_updated_successfully', 'Reminder updated successfully'),
    );
  }

  handleError(error) {
    if (error.status === 404) {
      toastr.error(this.props.t('account.dashboard_remind_me_reminder_already_deleted', 'Reminder already deleted.'));
    } else {
      super.handleError(error);
    }
  }

  render() {
    const reminder = this.props.reminder;
    return <div>
      {<Modal size="md" modalId={`editReminderModal-${reminder.user_reminder_id}`}
        open={this.state.openModal}
        onClose={() => this.setOpenModal(false)}
        >
        {this.state.openModal && <EditReminderForm 
          reminderTypes={this.props.reminderTypes}
          submitNewData={this.submitNewData}
          refreshList={this.props.refreshList}
          modalIdToDismiss={`editReminderModal-${reminder.user_reminder_id}`}
          reminder={reminder}
          onDelete={() => this.setOpenModal(false)}
          parseError={this.parseError}
        />
        }
      </Modal>}
      <button
        type='button'
        onClick={() => this.setOpenModal(true)}
        className='edit-reminder-button'
      >
        <HTMLTrans id='account.dashboard_edit_reminder'>Edit</HTMLTrans>
      </button>
    </div>
  }
}

const enhance = compose(withTranslationProvider);
export default enhance(EditReminderModal);
export const undecorated = EditReminderModal;


// WEBPACK FOOTER //
// ./src/Account/RemindMe/EditReminderModal.js